import FWU_TARGET_TYPES from '../../enums/iot/fwuTargetTypes';
import {showDeviceIsInSblModalAction} from '../../state/ducks/modal';
import {selectIsFwuPage} from '../../state/selectors/global';
import {makeSelectIotDeviceData, selectIsFirmwareStarted} from '../../state/selectors/iotDevice';
import {dispatch, getState} from '../../state/store';
import fwuService from '../device/fwuService';
import iotDeviceSettingsService from './iotDeviceSettingsService';

const getIsDeviceInSblMode = (iotDevice) => {
    if (!iotDevice) return {};

    const {is_device_in_sbl_mode: isDeviceInSblMode} = iotDevice.device || {};
    const {is_device_in_sbl_mode: isDeviceEngineInSblMode} = iotDevice.device_engine || {};
    const isHolderInSBLMode = iotDeviceSettingsService.isHolderInSBLMode(iotDevice);
    const isHolderEngineInSblMode = iotDeviceSettingsService.isHolderEngineInSBLMode(iotDevice);
    const isSblMode = isDeviceInSblMode || isDeviceEngineInSblMode || isHolderInSBLMode || isHolderEngineInSblMode;
    const isHolderSbl = isHolderInSBLMode || isHolderEngineInSblMode;

    return {isHolderSbl, isSblMode};
};

const checkIfDeviceIsInSblMode = (iotDevice, forceCheck) => {
    if (!iotDevice) return {};

    const {isHolderSbl, isSblMode} = getIsDeviceInSblMode(iotDevice);
    const state = getState();
    const isFwuPage = selectIsFwuPage(state);
    const isCheckEnabled = forceCheck || !isFwuPage;

    if (isSblMode && isCheckEnabled) {
        const isFwuInProgress = selectIsFirmwareStarted(state);
        const {is_device_in_sbl_mode: isDeviceInSblMode} = iotDevice.device || {};
        const isHolderInSBLMode = iotDeviceSettingsService.isHolderInSBLMode(iotDevice);
        const device_fwu_target = isDeviceInSblMode ? FWU_TARGET_TYPES.CHARGER_OR_MONO : FWU_TARGET_TYPES.MONO_ENGINE;
        const holder_fwu_target = isHolderInSBLMode ? FWU_TARGET_TYPES.HOLDER_DEVICE : FWU_TARGET_TYPES.HOLDER_ENGINE;
        const fwu_target = isHolderSbl ? holder_fwu_target : device_fwu_target;

        if (isFwuInProgress) {
            fwuService.initiateUpdateFirmwareMessage(fwu_target);
        } else {
            dispatch(showDeviceIsInSblModalAction({isInitialFlow: true, fwu_target}));
        }
    }

    return {isHolderSbl, isSblMode};
};

const checkIfDeviceIsInSblModeStatic = (forceCheck) => {
    const iotDevice = makeSelectIotDeviceData()(getState());

    return checkIfDeviceIsInSblMode(iotDevice, forceCheck);
};
const getIsDeviceInSblModeStatic = () => {
    const iotDevice = makeSelectIotDeviceData()(getState());

    return getIsDeviceInSblMode(iotDevice);
};

export default {
    checkIfDeviceIsInSblMode,
    checkIfDeviceIsInSblModeStatic,
    getIsDeviceInSblModeStatic,
};
